<template>
  <div class="Trafficlight" :class="className">
    <div class="light-box" :class="main ? 'main' : ''">
      <div class="light-item" :class="className === 'red' ? 'red' : ''"></div>
      <div
        class="light-item"
        :class="className === 'yellow' ? 'yellow' : ''"
      ></div>
      <div
        class="light-item"
        :class="className === 'green' ? 'green' : ''"
      ></div>
    </div>
    <div class="desc-group" :class="main ? 'main' : ''">
      <div class="desc">id：{{ remainingTimes || '--' }}</div>
      <div class="desc">duration：{{ totalTimes || '--' }}秒</div>
      <div class="desc">{{ className === 'UNKNOWN' ? 'unknown' : '' }}</div>
      <div class="desc">{{ !!main ? main : '' }}</div>
      <div class="desc">{{ !!title ? title : '' }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  remainingTimes: String,
  totalTimes: String,
  className: String,
  title: String,
  main: String,
});
</script>
<script>
export default {
  name: 'MainTrafficlightItem',
};
</script>

<style lang="less" scoped>
.Trafficlight {
  position: relative;
  color: #fff;
  align-items: center;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 284px;

  .desc {
    width: 202px;
    height: 20px;
    background: url(@/assets/images/traffic-light-bg.png) no-repeat;
    background-size: 100% 100%;
    padding-left: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    font-size: 14px;
  }

  .light-box {
    border-radius: 30px;
    width: 60px;
    height: 129px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 15px 0;
    box-sizing: border-box;
    align-items: center;
    background: #003d3b;

    .light-item {
      width: 29px;
      height: 29px;
      border-radius: 50%;
      background: #575757;
      box-shadow: 0 4px 8px 0 #0000003d;

      &.red {
        background: #ff3134;
      }

      &.yellow {
        background: #ffb637;
      }

      &.green {
        background: #37ffb9;
      }
    }
  }
}
</style>
